import { RequiredEmployeeModel } from "./employee.model";

export class JobberModel {
    workHours: any;
    workDays: any;
    country: string;
    city: string;

    name: string;
    uid: string;
    image: string;
    phone: string;
    email: string;

    createdOn: string;
    modifiedOn: string;
    
    status: JobberAppStatusEnum;

    constructor() {
        this.status = JobberAppStatusEnum.active;
    }
}

export enum JobberAppStatusEnum {
    active = "Active",
    employeed = "Employeed",
    expired = "Expired"
}

export class JobberMatchModel {
    matchId: string;
    company: RequiredEmployeeModel;
    jobber: JobberModel;
    jobberId: string;
    companyId: string;

    createdOn: string;

    constructor(company: RequiredEmployeeModel, jobber: JobberModel) {
        this.company = company;
        this.jobber = jobber;
        this.matchId = company.cid.concat(jobber.uid);

        this.jobberId = jobber.uid;
        this.companyId = company.cid;

        this.createdOn = new Date().toDateString();
    }
}


// WEBPACK FOOTER //
// ./src/models/jobber.model.ts